/**
 * Time & Attendance — Daily Attendance (Colombia) quick start.
 */

export const PEOPLE_ATTENDANCE_TOUR_ID = "people-attendance-v1";

export const PEOPLE_ATTENDANCE_TOUR_STEPS = [
  {
    id: "month",
    route: "/people/shifts",
    selector: "[data-tour='attendance-month']",
    title: "Pick the month",
    description:
      "Move between months to plan where you will work. This calendar is for Colombia Daily Attendance only.",
    placement: "bottom",
  },
  {
    id: "legend",
    route: "/people/shifts",
    selector: "[data-tour='attendance-legend']",
    title: "Status colors",
    description:
      "Office, home office, TDY / Training, leave, and holidays each have a color. Home office is limited so you keep enough office days each week.",
    placement: "bottom",
  },
  {
    id: "calendar",
    route: "/people/shifts",
    selector: "[data-tour='attendance-calendar']",
    title: "Set each day",
    description:
      "Tap a day to choose At office, Home office, or TDY / Training. You can edit future days and today until 8:00 AM Colombia time; past days need HR.",
    placement: "top",
  },
];
